import { oneOfType, string } from 'prop-types';
import Actions from '../actions/Actions';
import Ng1DrillDownAction from '../../ng1-drill-down/Ng1DrillDownAction';
import PanBackAction from '../actions/PanBackAction';
import PanForwardAction from '../actions/PanForwardAction';
import ZoomInAction from '../actions/ZoomInAction';
import ZoomOutAction from '../actions/ZoomOutAction';
import ResetAction from '../actions/ResetAction';
import ReportAction, { reportActionOptionsType } from '../actions/ReportAction';
import { usePageId } from '../page/PageUtils';
import messageDescriptor from '../../lingui/LinguiPropTypes';

export default function PageActionsWithNg1DrillDown({ pageTitle, reportActionOptions }) {
    const pageId = usePageId();

    return (
        <Actions>
            <Ng1DrillDownAction tooltipPlacement="bottom" />
            <PanBackAction tooltipPlacement="bottom" />
            <PanForwardAction tooltipPlacement="bottom" />
            <ZoomInAction tooltipPlacement="bottom" />
            <ZoomOutAction tooltipPlacement="bottom" />
            <ResetAction tooltipPlacement="bottom" />
            <ReportAction
                pageId={pageId}
                pageTitle={pageTitle}
                options={reportActionOptions}
                tooltipPlacement="bottom"
            />
        </Actions>
    );
}

PageActionsWithNg1DrillDown.propTypes = {
    pageTitle: oneOfType([messageDescriptor, string]),
    reportActionOptions: reportActionOptionsType,
};

PageActionsWithNg1DrillDown.defaultProps = {
    pageTitle: undefined,
    reportActionOptions: undefined,
};
